import React, { useContext, useState } from 'react';
import { Modal } from '@material-ui/core';
import {
  Typography,
  IconButton,
  Divider,
  Toolbar,
  AppBar,
  Button,
  Box,
  useTheme,
} from '@mui/material';
import {
  VideoCameraBack,
  PictureAsPdf,
  Close,
  TextDecrease,
  TextIncrease,
  LightMode,
  DarkMode,
  Language,
  HdrAuto,
} from '@mui/icons-material';
import { BsFillVolumeUpFill } from 'react-icons/bs'
import { DiAndroid } from 'react-icons/di'
import { AiFillWindows } from 'react-icons/ai'
import { BsApple } from 'react-icons/bs'
import { makeStyles } from '@mui/styles';
import { ColorModeContext } from '../../../../App';

const eServiceArray = [
  {
    href: 'https://tcp.hp.gov.in/Download/UM_HPTCP_CITIZEN_PORTAL.pdf',
    label: 'Download User Manual for TCP Citizen/Private Professional Portal',
    icon: 'pdf'
  }, {
    href: 'https://tcp.hp.gov.in/Download/UM_HPTCP_OFFICER_PORTAL.pdf',
    label: 'Download User Manual for TCP Officer Portal',
    icon: 'pdf'
  }, {
    href: 'https://tcp.hp.gov.in/Download/TCP_form10.wmv',
    label: 'Download Video Tutorial for Private Professional Registration',
    icon: 'wmv'
  }, {
    href: 'https://tcp.hp.gov.in/Download/TCP_form11.wmv',
    label: 'Download Video Tutorial for Subdivision of Land',
    icon: 'wmv'
  }, {
    href: 'https://tcp.hp.gov.in/Download/TCP_form12.wmv',
    label: 'Download Video Tutorial for Building Permission',
    icon: 'wmv'
  }, {
    href: 'https://tcp.hp.gov.in/Download/TCP_form26.wmv',
    label: 'Download Video Tutorial for Deviation',
    icon: 'wmv'
  },
];

const useStyles = makeStyles((theme) => ({
  appBar: {
    '&.MuiPaper-root': {
      backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#999',
      color: theme.palette.mode === 'light' ? 'black' : 'white',
      minHeight: '2.25rem',
    },
  },
  toolbar: {
    '&.MuiToolbar-root': {
      justifyContent: 'space-between',
      paddingBlock: '0.25rem',
      minHeight: '2.25rem',
    }
  },
  flexBox: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
  icons: {
    borderRight: '1px solid rgba(85, 85, 85, 0.25)',
    paddingRight: '0.75rem',
    alignItems: 'center',
    display: 'flex',
  },
  divider: {
    '&.MuiDivider-flexItem': {
      backgroundColor: '#555',
      marginInline: '0.75rem',
      height: 'auto',
    }
  },
  eServiceUserGuide: { padding: 5, cursor: 'pointer' },
  eMapLoginBtn: { width: 130, height: 35, backgroundColor: '#207CBD !important', color: 'white !important' },
  skip2Main: { fontSize: '14px !important', margin: '0 20px', cursor: 'pointer' },
  language: { fontSize: '1rem !important', display: 'flex', alignItems: 'center', gap: '0.5rem' },
  iconBtn: { width: 22, height: 22, margin: '0 4px' },
  searchField: {
    background: `${theme.palette.mode === 'light' ? 'white' : '#bbb'} url(https://tcp.hp.gov.in/img/search.png) no-repeat calc(100% - 10px) center`,
    border: `1px solid ${theme.palette.mode === 'light' ? '#eee' : '#aaa'}`,
    padding: '5px 10px',
  },
  iconStyle: {
    width: 25,
    height: 25,
    borderRadius: '50%',
    border: '2px solid #1F4A7C',
    color: '#1F4A7C',
  },
}));

function Strip() {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const classes = useStyles()
  const [userGuidePop, setUserGuidePop] = useState(false);

  const toggleUserGuide = () => {
    setUserGuidePop(state => !state);
  };

  return (
    <React.Fragment>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Box className={classes.flexBox}>
            <Box className={classes.icons}>
              <IconButton size="small" aria-label="screenReader" onClick={() => window.open('https://tcp.hp.gov.in/screenReader', "_blank")}>
                <BsFillVolumeUpFill className={classes.iconStyle} />
              </IconButton>
              <IconButton size="small" aria-label="android app" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.csm.hptcp.hptcpmobileapp', "_blank")}>
                <DiAndroid className={classes.iconStyle} />
              </IconButton>
              <IconButton size="small" aria-label="microsoft app" onClick={() => window.open('https://www.microsoft.com/en-in/store/p/him-tcp/9nblggh406mz', "_blank")}>
                <AiFillWindows className={classes.iconStyle} />
              </IconButton>
              <IconButton size="small" aria-label="apple/iOS app" onClick={() => window.open('https://itunes.apple.com/us/app/him-tcp/id1161638555?ls=1&mt=8', "_blank")}>
                <BsApple className={classes.iconStyle} />
              </IconButton>
            </Box>

            <Typography variant='p' className={classes.eServiceUserGuide} onClick={toggleUserGuide}>e-service User Guide</Typography>
            <Button onClick={() => window.open('https://tcp.hp.gov.in/login/4', "_blank")} className={classes.eMapLoginBtn}>E-Map Login</Button>
          </Box>
          <a href="#skip2main" className={classes.skip2Main}>Skip to main content</a>
          <Box className={classes.flexBox}>
            {/* <Typography variant='p' className={classes.eServiceUserGuide} onClick={toggleUserGuide}>e-service User Guide</Typography>
          <Button onClick={() => window.open('https://tcp.hp.gov.in/login/4', "_blank")} className={classes.eMapLoginBtn}>E-Map Login</Button> */}

            <Box className={classes.icons}>
              <IconButton size='small'><TextDecrease /></IconButton>
              <IconButton size='small'><HdrAuto /></IconButton>
              <IconButton size='small'><TextIncrease /></IconButton>
              <Divider orientation="vertical" variant="middle" flexItem className={classes.divider} />
              <IconButton size='small' onClick={colorMode.toggleThemeMode}>
                {theme.palette.mode === 'light' ? <DarkMode /> : <LightMode />}
              </IconButton>
              {/*
            <img src='https://www.hsvphry.org.in/assets/img/font-small.png' alt='decrease' className={classes.iconBtn} />
            <img src='https://www.hsvphry.org.in/assets/img/font-normal-size.png' alt='increase' className={classes.iconBtn} />
            <img src='https://www.hsvphry.org.in/assets/img/font-small.png' alt='normal' className={classes.iconBtn} />
            <img src='https://www.hsvphry.org.in/assets/img/font-white.png' alt='dark' className={classes.iconBtn} />
            <img src='https://www.hsvphry.org.in/assets/img/font-black.png' alt='default' className={classes.iconBtn} />
            */}
            </Box>
            <Button className={classes.language}><Language /> <Typography>हिंदी</Typography></Button>
            <input className={classes.searchField} type='text' placeholder='Search here...' />
          </Box>
        </Toolbar>
      </AppBar>

      <Modal open={userGuidePop} onClose={toggleUserGuide}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', borderRadius: '10px', outline: 'none' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 10px 10px 20px', borderBottom: '1px solid #eee' }}>
            <Typography variant="h5" component="h2">
              e-Services User Guide
            </Typography>

            <IconButton aria-label="close" onClick={toggleUserGuide}>
              <Close />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px 20px 10px' }}>
            {eServiceArray.map(({ href, label, icon }, index) => (
              <a key={`${href}_${index}`} href={href} target='_blank' style={{ display: 'flex', alignItems: 'center', gap: '1rem', backgroundColor: '#dceefb', borderRadius: '5px', padding: '1rem', marginBottom: '1rem' }}>
                {label} {icon === 'pdf' ? <PictureAsPdf /> : <VideoCameraBack />}
              </a>
            ))}
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export default Strip
